
import Vue from 'vue'

export default Vue.extend({
  computed: {
    peerId(): string | null {
      return this.$ipfs.identity?.id.toString() || null
    },

    avatarURL(): string | null {
      return this.$accessor.ipfs.avatarURL
    }
  }
})
